import { computed } from 'vue';
import { i18n } from '@/i18n';
import { loadPageView } from '@/utility/index';
import middleware from './middleware';
// ServerLayout should be lazy-loaded to avoid dynamic+static collisions

export default [
    {
        path: '/portfolio',
        name: 'portfolio',
        component: loadPageView('portfolio'),
        beforeEnter: middleware.user,
        meta: { title: computed(() => i18n.global.t('Portfolio')) }
    },
    {
        path: '/portfolio/orders',
        name: 'portfolio_orders',
        component: loadPageView('portfolio/OrdersPage'),
        beforeEnter: middleware.user,
        meta: { title: computed(() => i18n.global.t('Orders')) }
    },
    {
        path: '/browse-assets',
        name: 'browse_assets',
        component: () => import('@/pages/portfolio/BrowseAssetsPage.vue'),
        beforeEnter: middleware.all,
        meta: { title: computed(() => i18n.global.t('Browse Assets')) }
    },
    {
        path: '/trade/:symbol',
        name: 'trade_symbol',
        props: true,
        component: () => import('@/pages/portfolio/TradingViewPage.vue'),
        beforeEnter: middleware.all,
        meta: { title: computed(() => i18n.global.t('Trade')) }
    },
    {
        path: '/instrument/:assetId',
        name: 'instrument_detail',
        props: true,
        component: () => import('@/pages/ServerLayout.vue'),
        beforeEnter: middleware.all,
        meta: { title: computed(() => i18n.global.t('Instrument Detail')) }
    }
];
